export function formatHourMinutes(date, isChinese = false) {
  const d = new Date(date);
  let hh, m, s
  hh = d.getHours();
  m = d.getMinutes();
  s = d.getSeconds();
  var dd = "AM";
  if (isChinese) {
    dd = "上午"
  }
  var h = hh;
  if (h >= 12) {
    h = hh - 12;
    dd = "PM";
    if (isChinese) {
      dd = "下午"
    }
  }
  m = m < 10 ? "0" + m : m;

  s = s < 10 ? "0" + s : s;

  /* if you want 2 digit hours:
  h = h<10?"0"+h:h; */
  h = h<10?"0"+h:h;

  var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);

  var replacement = h + ":" + m;
  /* if you want to add seconds
  replacement += ":"+s;  */
  if (!isChinese) {
    replacement += " " + dd;
  } else {
    replacement = dd + " " + replacement;
  }

  return replacement;
}

export function formatDateHourMinutes (date, isChinese = false) {
  var d = new Date(date);
  let hh, m, s
  hh = d.getHours();
  m = d.getMinutes();
  s = d.getSeconds();
  var dd = "AM";
  if (isChinese) {
    dd = "上午"
  }
  var h = hh;
  if (h >= 12) {
    h = hh - 12;
    dd = "PM";
    if (isChinese) {
      dd = "下午"
    }
  }
  m = m < 10 ? "0" + m : m;

  s = s < 10 ? "0" + s : s;

  /* if you want 2 digit hours:
  h = h<10?"0"+h:h; */
  h = h<10?"0"+h:h;

  var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);

  var replacement = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  /* if you want to add seconds
  replacement += ":"+s;  */
  if (!isChinese) {
    replacement += " " +h + ":" + m  + " " + dd;
  } else {
    replacement = replacement + " " + dd +h + ":" + m;
  }

  return replacement;
}

export function formatDate (date) {
  const d = new Date(date);
  return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
}

export function isToday (date) {
  const td = new Date(date);
  var d = new Date();
  return td.getDate() === d.getDate() && td.getMonth() === d.getMonth() && td.getFullYear() === d.getFullYear();
}

export function getHours(date) {
  const d = new Date(date);
  return d.getHours();
}

export function getMinutes(date) {
  const d = new Date(date);
  return d.getMinutes();
}

export function isAfter(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return d1.getTime() >= d2.getTime()
}

export function isBefore(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return d1.getTime() <= d2.getTime()
}

export function formatTime (date) {
  return date.replace(/-/g, "/")
}
